import React from 'react'
import styled from 'styled-components'

import { Spinner } from '@8x8/oxygen-loaders'

import commonCss from '~/core/css'

const Container = styled.div`
  ${commonCss.flexAllCenter};

  height: 100%;
`

const StyledSpinner = ({ className, style }) => (
  <Container className={className} style={style}>
    <Spinner size={40} />
  </Container>
)

export default StyledSpinner
